import React from "react";

const LINES = [
  { t: "bryson nyamwange", cls: "h1" },
  { t: "_software engineer · distributed systems & cloud_", cls: "" },
  { t: "", cls: "" },
  { t: "summary", cls: "h2" },
  { t: "Five+ years designing, developing and deploying scalable", cls: "" },
  { t: "web and backend systems. Strong fundamentals — architecture,", cls: "" },
  { t: "data structures, algorithms — paired with hands-on **CI/CD**,", cls: "" },
  { t: "observability and **cloud infrastructure** experience.", cls: "" },
  { t: "", cls: "" },
  { t: " focus", cls: "h2" },
  { t: "- Distributed backend services in `typescript` + `nestjs`", cls: "" },
  { t: "- AWS infrastructure via `terraform` + GitOps (`argocd`)", cls: "" },
  { t: "- Observability stacks: `prometheus` + `grafana`", cls: "" },
  { t: "- Accessible, well-tested products that ship", cls: "" },
  { t: "", cls: "" },
  { t: "currently", cls: "h2" },
  { t: "Software Engineer at **Kitrel LLC**", cls: "" },
  {
    t: "Recently: 2nd place, [GPT-5 Hackathon 2025](https://lablab.ai/ai-hackathons/co-creating-with-gpt-5/ctrlaltelite/echojournal-guided-multimodal-ai-journaling).",
    cls: "",
  },
];

// Inline-md tokens supported: **bold**, _italic_, `code`, [text](url)
const TOKEN_RE = /(\*\*[^*]+\*\*|_[^_]+_|`[^`]+`|\[[^\]]+\]\([^)]+\))/g;

function renderInline(text) {
  if (!text) return " ";
  const parts = text.split(TOKEN_RE);
  return parts.map((part, i) => {
    if (!part) return null;
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith("_") && part.endsWith("_")) {
      return <em key={i}>{part.slice(1, -1)}</em>;
    }
    if (part.startsWith("`") && part.endsWith("`")) {
      return <code key={i}>{part.slice(1, -1)}</code>;
    }
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (link) {
      return (
        <a key={i} href={link[2]} target="_blank" rel="noreferrer">
          {link[1]}
          <span className="sr-only"> (opens in new tab)</span>
        </a>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

export default function About() {
  return (
    <section id="about">
      <div className="section-head">
        <div className="label">§01 · about</div>
        <div className="h">Profile and focus areas</div>
        <div></div>
      </div>

      <div className="about-grid">
        {/* ABOUT.md pane */}
        <div className="pane md-pane">
          <div className="pane-hd">
            <div className="dots"><i /><i /><i /></div>
            <div className="path">~/portfolio/ABOUT</div>
            <div className="right">
              <span>UTF-8</span>
              <span>md</span>
            </div>
          </div>
          <div className="pane-bd">
            <div className="nums">
              {LINES.map((_, i) => (
                <span key={i}>{String(i + 1).padStart(2, "0")}</span>
              ))}
            </div>
            <div className="body">
              {LINES.map((ln, i) => (
                <div key={i} className={ln.cls}>
                  {renderInline(ln.t)}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* /proc/bryson pane */}
        <div className="pane sys-pane">
          <div className="pane-hd">
            <div className="dots"><i /><i /><i /></div>
            <div className="path">/proc/bryson</div>
            <div className="right">
              <span>--all</span>
            </div>
          </div>
          <div className="pane-bd body">
            <pre className="ascii">{`     ╭───╮
   ╭─┤ B ├─╮     ┌──── kitrel  ·  software engineer
   │ ╰───╯ │     ├──── badili ·  software engineer
   │       │     ├──── stax   ·  software engineer
   ╰───────╯     ├──── andela ·  technical mentor
                   └──── treasury · intern (technical analyst)`}</pre>

            <div className="sysinfo">
              <div className="k">role</div>
              <div className="v"><b>Software Engineer</b> · Kitrel LLC</div>

              <div className="k">degree</div>
              <div className="v"><b>BSc Mathematics</b> · Technical University of Kenya</div>

              <div className="k">training</div>
              <div className="v">Udacity Cloud DevOps · ALX SE · Google GADS</div>

              <div className="k">certs</div>
              <div className="v">· AWS SAA · KCNA · CCP · ACA · CDE</div>

              <div className="k">shell</div>
              <div className="v">zsh + bash + nvim</div>

              <div className="k">availability</div>
              <div className="v">
                <span className="bar">
                  <i className="on" /><i className="on" /><i className="on" /><i className="on" />
                  <i className="on" /><i className="on" /><i className="on" /><i />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
